// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Checkbox Component Styles */

.scl--web-component-checkbox-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 40px;
  cursor: pointer;
  user-select: none;
}

.scl--web-component-checkbox-container.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Hide native checkbox */
.scl--web-component-checkbox-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

/* Custom checkbox box - Default state */
.scl--web-component-checkbox-box {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px;
  gap: 10px;
  width: 22px;
  height: 22px;
  border: 1px solid #7D8187;
  background: transparent;
  transition: border-color 0.3s ease, background-color 0.3s ease;
  flex: none;
  flex-grow: 0;
}

/* Hover state */
.scl--web-component-checkbox-box:hover {
  border-color: #FFFFFF;
}

/* Selected/Checked state */
.scl--web-component-checkbox-box.checked {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 10px;
  width: 22px;
  height: 22px;
  background: rgba(105, 131, 94, 1);
  border: 1px solid rgba(164, 186, 156, 1);
}


.scl--web-component-checkbox-box.disabled {
  cursor: not-allowed;
}

/* Check icon */
.scl--web-component-checkbox-check-icon {
  width: 14px;
  height: 14px;
  flex: none;
  flex-grow: 0;
}

/* Label */
.scl--web-component-checkbox-label {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  flex: none;
  flex-grow: 0;
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/checkbox/css/checkbox.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,8DAA8D;EAC9D,UAAU;EACV,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,wCAAwC;AAC1C;;;AAGA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,YAAY;AACd","sourcesContent":["/* Checkbox Component Styles */\n\n.scl--web-component-checkbox-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  gap: 40px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.scl--web-component-checkbox-container.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* Hide native checkbox */\n.scl--web-component-checkbox-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n}\n\n/* Custom checkbox box - Default state */\n.scl--web-component-checkbox-box {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  gap: 10px;\n  width: 22px;\n  height: 22px;\n  border: 1px solid #7D8187;\n  background: transparent;\n  transition: border-color 0.3s ease, background-color 0.3s ease;\n  flex: none;\n  flex-grow: 0;\n}\n\n/* Hover state */\n.scl--web-component-checkbox-box:hover {\n  border-color: #FFFFFF;\n}\n\n/* Selected/Checked state */\n.scl--web-component-checkbox-box.checked {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  gap: 10px;\n  width: 22px;\n  height: 22px;\n  background: rgba(105, 131, 94, 1);\n  border: 1px solid rgba(164, 186, 156, 1);\n}\n\n\n.scl--web-component-checkbox-box.disabled {\n  cursor: not-allowed;\n}\n\n/* Check icon */\n.scl--web-component-checkbox-check-icon {\n  width: 14px;\n  height: 14px;\n  flex: none;\n  flex-grow: 0;\n}\n\n/* Label */\n.scl--web-component-checkbox-label {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: #FFFFFF;\n  flex: none;\n  flex-grow: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
